import * as React from "react";
import axiosInstance from "../../Api/Axios";

import Select from "../../Components/Select";

const CountrySelect = (props) => {
  const { ...rest } = props;

  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/destination-countires`)
      .then((response) => {
        setData(response.data.data || []);
      });
  }, []);

  return (
    <Select {...rest}>
      <option value=""></option>
      {data.map((country) => {
        return (
          <option key={country.id} value={country.id}>
            {country.name}
          </option>
        );
      })}
    </Select>
  );
};

export default CountrySelect;
